"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configuration = void 0;
exports.setConfiguration = setConfiguration;
exports.configuration = {
    init: false,
    environment: "",
    cookieDomain: "",
    authorizeTrustpilotApiHosts: [],
    trustpilotApi: {
        host: "",
    },
    businessAuthentication: {
        host: "",
        clientId: "",
    },
    businessAppAuthenticationApi: {
        host: "",
    },
};
function setConfiguration(config) {
    exports.configuration = {
        init: true,
        environment: config.Environment,
        cookieDomain: config.CookieDomain,
        authorizeTrustpilotApiHosts: config.AuthorizeTrustpilotApiHosts.split(",")
            .map(function (x) { return x.trim(); })
            .filter(function (x) { return x.length > 0; }),
        trustpilotApi: {
            host: config["TrustpilotApi.Host"],
        },
        businessAuthentication: {
            host: config["BusinessAuthentication.Host"],
            clientId: config["BusinessAuthentication.ClientId"],
        },
        businessAppAuthenticationApi: {
            host: config["BusinessAppAuthenticationApi.Host"],
        },
    };
}
//# sourceMappingURL=configuration.js.map